<template>
  <div class="card-info">
    <div class="card-info__img">
      <img :src="data.image" alt="Alt description for the image" />
    </div>
    <div class="card-info__wrapper">
      <TextProse>
        <h2 v-html="data.title">{{ data.title }}</h2>
        <p v-html="data.text">{{ data.text }}</p>
        <BaseButton
          v-if="data.button"
          href="#"
          class="card-info__button"
          variant="primary"
          :aria-label="aria"
        >{{ data.button }}</BaseButton>
        <p v-html="data.extra">{{ data.extra }}</p>
        <img v-if="data.pic" :src="data.pic" />
      </TextProse>
    </div>
  </div>
</template>

<script>
import BaseButton from '../elements/BaseButton.vue'
import TextProse from '../elements/TextProse.vue'
export default {
  name: 'CardInformation',
  components: { BaseButton, TextProse },
  props: ['data']
}
</script>

<style lang="postcss">
.card-info {
  @apply my-12 flex flex-wrap border border-t-0 border-l-0 border-r-0 border-body-lighter;
}
.card-info__header {
  @apply px-6 mb-8;
}
.card-info .prose h2 {
  @apply text-body;
}
.card-info .prose a {
  @apply text-white font-normal text-base;
}
.card-info .prose a:hover {
  @apply text-white font-normal;
}
.card-info__img {
  @apply flex justify-start items-start w-full mb-8;
}
.card-info__img img {
  @apply w-auto max-w-xs pr-8;
}
.card-info__wrapper {
  @apply w-full;
}
.card-info__button ~ p {
  @apply mt-16;
}
@screen md {
  .card-info {
    @apply flex-no-wrap;
  }
  .card-info__img {
    @apply w-5/12 mb-0;
  }
  .card-info__img img {
    @apply w-auto max-w-full;
  }
  .card-info__header {
    @apply mb-12;
  }
}
</style>
